// extracted by mini-css-extract-plugin
module.exports = {"chipsWrapper":"selection-items_chipsWrapper__W7Ol6"};